// Language context for CloudGM Business
import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  ar: {
    // Navbar
    dashboard: 'لوحة التحكم',
    myStores: 'متاجري',
    products: 'المنتجات',
    login: 'تسجيل دخول',
    register: 'إنشاء حساب',
    logout: 'تسجيل خروج',
    
    // Home
    heroTitle: 'CloudGM Business',
    heroSubtitle: 'منصة التجار الشاملة',
    heroSubtitleEn: 'Your Complete Merchant Platform',
    heroDescription: 'انضم إلى آلاف التجار الناجحين على منصة CloudGM. أنشئ متجرك الإلكتروني، أدر منتجاتك، وزد مبيعاتك بسهولة',
    heroDescriptionEn: 'Join thousands of successful merchants on CloudGM platform. Create your online store, manage products, and boost your sales effortlessly',
    startFree: 'ابدأ الآن مجاناً',
    loginBtn: 'تسجيل الدخول',
    whyChoose: 'لماذا تختار CloudGM Business؟',
    merchantTypes: 'أنواع التجار',
    readyToStart: 'جاهز لبدء رحلتك؟',
    registerNow: 'سجل الآن مجاناً',
    
    // Features
    multipleStores: 'متاجر متعددة',
    multipleStoresDesc: 'أنشئ وأدر متاجر متعددة بتصاميم مخصصة',
    advancedAnalytics: 'تحليلات متقدمة',
    advancedAnalyticsDesc: 'تتبع مبيعاتك وأداء متاجرك بسهولة',
    reachThousands: 'وصول لآلاف العملاء',
    reachThousandsDesc: 'استفد من قاعدة عملاء CloudGM الواسعة',
    secureTransactions: 'معاملات آمنة',
    secureTransactionsDesc: 'نظام دفع آمن وموثوق',
    quickManagement: 'إدارة سريعة',
    quickManagementDesc: 'واجهة سهلة لإدارة منتجاتك وطلباتك',
    digitalPresence: 'تواجد رقمي',
    digitalPresenceDesc: 'متجرك متاح على الويب والموبايل',
    
    // Merchant Types
    realEstateMerchant: 'تاجر عقارات',
    numbersMerchant: 'تاجر أرقام',
    sparePartsMerchant: 'تاجر قطع غيار',
    autoMerchant: 'تاجر سيارات',
    authorizedAgent: 'وكيل معتمد',
    
    // Stats
    activeMerchants: 'تاجر نشط',
    monthlyTransactions: 'معاملة شهرية',
    merchantSatisfaction: 'رضا التجار',
    supportAvailable: 'دعم متواصل',
    
    // Register
    getStarted: 'ابدأ الآن',
    enterEmail: 'أدخل بريدك الإلكتروني لبدء تسجيل الأعمال',
    enterEmailPlaceholder: 'أدخل بريدك الإلكتروني',
    sendVerificationCode: 'إرسال رمز التحقق',
    verifyEmail: 'تحقق من بريدك',
    enterCode: 'أدخل الرمز المكون من 6 أرقام المرسل إلى',
    verify: 'تحقق',
    resendCode: 'إعادة إرسال الرمز',
    emailVerified: 'تم التحقق من البريد الإلكتروني ✓',
    phoneNumber: 'رقم الهاتف',
    enterPhone: 'أدخل رقم هاتفك للتحقق',
    sendCode: 'إرسال رمز التحقق',
    verifyPhone: 'تحقق من هاتفك',
    phoneVerified: 'تم التحقق من رقم الهاتف ✓',
    fullName: 'الاسم الكامل',
    fullNamePlaceholder: 'Full Name (English only)',
    fullNameNote: 'يرجى كتابة الاسم باللغة الإنجليزية فقط',
    continue: 'متابعة',
    reviewInfo: 'مراجعة البيانات',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    createAccount: 'إنشاء الحساب',
    termsNotice: 'بالنقر على "إنشاء الحساب"، أنت توافق على شروط الخدمة وسياسة الخصوصية',
    haveAccount: 'لديك حساب بالفعل؟',
    lookingCustomer: 'هل تبحث عن CloudGM كعميل؟',
    visitMarketplace: 'زيارة السوق',
    
    // Login
    loginTitle: 'تسجيل الدخول',
    password: 'كلمة المرور',
    noAccount: 'ليس لديك حساب؟',
    createNewAccount: 'إنشاء حساب جديد',
    areYouCustomer: 'هل أنت عميل؟',
    loginToCustomerPlatform: 'تسجيل الدخول لمنصة العملاء',
    
    // Dashboard
    welcome: 'مرحباً',
    totalStores: 'إجمالي المتاجر',
    activeProducts: 'المنتجات النشطة',
    ordersThisMonth: 'الطلبات هذا الشهر',
    totalSales: 'المبيعات',
    recentOrders: 'الطلبات الأخيرة',
    quickOverview: 'نظرة سريعة',
    conversionRate: 'معدل التحويل',
    avgOrderValue: 'متوسط قيمة الطلب',
    avgResponseTime: 'متوسط وقت الاستجابة',
    completed: 'مكتمل',
    pending: 'قيد المعالجة',
    
    // App Download
    downloadApp: 'تحميل تطبيق CLOUD GM BUSINESS',
    manageOrders: 'إدارة الطلبات، تتبع المبيعات والحصول على دعم العملاء',
    
    // Errors
    pleaseEnterEmail: 'يرجى إدخال البريد الإلكتروني',
    pleaseEnter6Digits: 'يرجى إدخال الرمز المكون من 6 أرقام',
    pleaseEnterPhone: 'يرجى إدخال رقم الهاتف',
    pleaseEnterName: 'يرجى إدخال الاسم بالكامل',
    englishOnly: 'يرجى كتابة الاسم باللغة الإنجليزية فقط',
    codeSentEmail: 'تم إرسال رمز التحقق إلى بريدك الإلكتروني',
    codeSentPhone: 'تم إرسال رمز التحقق إلى هاتفك',
    emailVerifiedSuccess: 'تم التحقق من البريد الإلكتروني بنجاح',
    phoneVerifiedSuccess: 'تم التحقق من رقم الهاتف بنجاح',
    accountCreated: 'تم إنشاء حسابك بنجاح!',
    loginSuccess: 'تم تسجيل الدخول بنجاح!',
    invalidCode: 'رمز التحقق غير صحيح',
    failedSendCode: 'فشل إرسال رمز التحقق',
    invalidCredentials: 'بيانات دخول غير صحيحة',
  },
  en: {
    // Navbar
    dashboard: 'Dashboard',
    myStores: 'My Stores',
    products: 'Products',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    
    // Home
    heroTitle: 'CloudGM Business',
    heroSubtitle: 'Your Complete Merchant Platform',
    heroSubtitleEn: '',
    heroDescription: 'Join thousands of successful merchants on CloudGM platform. Create your online store, manage products, and boost your sales effortlessly',
    heroDescriptionEn: '',
    startFree: 'Start Free',
    loginBtn: 'Login',
    whyChoose: 'Why Choose CloudGM Business?',
    merchantTypes: 'Merchant Categories',
    readyToStart: 'Ready to Start Your Journey?',
    registerNow: 'Register Now Free',
    
    // Features
    multipleStores: 'Multiple Stores',
    multipleStoresDesc: 'Create and manage multiple stores with custom designs',
    advancedAnalytics: 'Advanced Analytics',
    advancedAnalyticsDesc: 'Track your sales and store performance easily',
    reachThousands: 'Reach Thousands',
    reachThousandsDesc: "Benefit from CloudGM's wide customer base",
    secureTransactions: 'Secure Transactions',
    secureTransactionsDesc: 'Safe and reliable payment system',
    quickManagement: 'Quick Management',
    quickManagementDesc: 'Easy interface to manage products and orders',
    digitalPresence: 'Digital Presence',
    digitalPresenceDesc: 'Your store available on web and mobile',
    
    // Merchant Types
    realEstateMerchant: 'Real Estate Merchant',
    numbersMerchant: 'Numbers Merchant',
    sparePartsMerchant: 'Spare Parts Merchant',
    autoMerchant: 'Auto Merchant',
    authorizedAgent: 'Authorized Agent',
    
    // Stats
    activeMerchants: 'Active Merchants',
    monthlyTransactions: 'Monthly Transactions',
    merchantSatisfaction: 'Merchant Satisfaction',
    supportAvailable: 'Support Available',
    
    // Register
    getStarted: 'Get Started',
    enterEmail: 'Enter your email address to begin business registration',
    enterEmailPlaceholder: 'Enter your business email',
    sendVerificationCode: 'Send Verification Code',
    verifyEmail: 'Verify Your Email',
    enterCode: 'Enter the 6-digit code sent to',
    verify: 'Verify',
    resendCode: 'Resend Code',
    emailVerified: 'Email Verified ✓',
    phoneNumber: 'Phone Number',
    enterPhone: 'Enter your phone number for verification',
    sendCode: 'Send Code',
    verifyPhone: 'Verify Your Phone',
    phoneVerified: 'Phone Verified ✓',
    fullName: 'Full Name',
    fullNamePlaceholder: 'Full Name (English only)',
    fullNameNote: 'Please enter your name in English only',
    continue: 'Continue',
    reviewInfo: 'Review Your Information',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    createAccount: 'Create Account',
    termsNotice: 'By clicking "Create Account", you agree to our Terms of Service and Privacy Policy',
    haveAccount: 'Already have an account?',
    lookingCustomer: 'Looking to use CloudGM as a Customer?',
    visitMarketplace: 'Visit our Marketplace',
    
    // Login
    loginTitle: 'Login',
    password: 'Password',
    noAccount: "Don't have an account?",
    createNewAccount: 'Create new account',
    areYouCustomer: 'Are you a customer?',
    loginToCustomerPlatform: 'Login to customer platform',
    
    // Dashboard
    welcome: 'Welcome',
    totalStores: 'Total Stores',
    activeProducts: 'Active Products',
    ordersThisMonth: 'Orders This Month',
    totalSales: 'Total Sales',
    recentOrders: 'Recent Orders',
    quickOverview: 'Quick Overview',
    conversionRate: 'Conversion Rate',
    avgOrderValue: 'Average Order Value',
    avgResponseTime: 'Average Response Time',
    completed: 'Completed',
    pending: 'Pending',
    
    // App Download
    downloadApp: 'Download the CLOUD GM BUSINESS App',
    manageOrders: 'Manage orders, track sales and get customer support',
    
    // Errors
    pleaseEnterEmail: 'Please enter your email',
    pleaseEnter6Digits: 'Please enter the 6-digit code',
    pleaseEnterPhone: 'Please enter your phone number',
    pleaseEnterName: 'Please enter your full name',
    englishOnly: 'Please enter your name in English only',
    codeSentEmail: 'Verification code sent to your email',
    codeSentPhone: 'Verification code sent to your phone',
    emailVerifiedSuccess: 'Email verified successfully',
    phoneVerifiedSuccess: 'Phone verified successfully',
    accountCreated: 'Account created successfully!',
    loginSuccess: 'Login successful!',
    invalidCode: 'Invalid verification code',
    failedSendCode: 'Failed to send verification code',
    invalidCredentials: 'Invalid credentials',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('cloudgm_language') || 'ar';
  });

  useEffect(() => {
    localStorage.setItem('cloudgm_language', language);
    document.documentElement.setAttribute('dir', language === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ar' ? 'en' : 'ar');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
